<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-layout align-center justify-center column pb-2>
          <h2 class="heading-3">Register with email</h2>
        </v-layout>

        <v-alert :value="true" v-if="error != null" type="error" v-html="error.message"></v-alert>

        <v-layout justify-center column>

          <v-form ref="form" v-model="valid" @submit="signUp">
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="firstName" :rules="firstNameRules" label="First Name *"
                  required></v-text-field>
              </v-flex>

              <v-flex xs12 pb-0>
                <v-text-field outline v-model="lastName" :rules="lastNameRules" label="Last Name *"
                  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="username" :rules="usernameRules" type="email" label="Email Address *"
                  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 sm2>Date of Birth*</v-flex>
              <v-flex xs12 sm3>
                <v-select :items="days" label="DD" v-model="dobDay" :rules="dobRules" required outline></v-select>
              </v-flex>
              <v-flex xs12 sm3>
                <v-select :items="months" label="MM" v-model="dobMonth" :rules="dobRules" outline required></v-select>
              </v-flex>
              <v-flex xs12 sm4>
                <v-select :items="years" label="YYYY" v-model="dobYear" :rules="dobRules" outline required></v-select>
              </v-flex>
            </v-layout>


            <v-layout row v-if="this.configValues.accountGenderRequested === true">
              <v-flex xs12>
                <v-select :items="this.configValues.accountGenderList" label="Gender" v-model="gender"
                  outline></v-select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                Address:</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="address1" :rules="addressRules" label="Address line 1*"
                  required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="address2" :rules="addressRules" label="Address line 2*"
                  required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="address3" label="Address line 3"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="locality" :rules="addressRules" label="City / Town*"
                  required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="region" label="County / Region"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="postal_code" :rules="addressRules" label="Postal Code*"
                  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-select outline :items="countries" v-model="country" item-text="name" :rules="countryRules"
                  label="Country*"></v-select>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline v-model="phone_number" :rules="phoneNumberRules" label="Phone Number*"
                  required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                Set your password:</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field outline ref="pass" v-model="pass" :rules="passRules" label="Password *" type="password"
                  required></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field outline ref="passConfirm" v-model="passConfirm" :rules="passConfirmRules"
                  label="Confirm Password *" type="password" required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <p class="password-notice">A valid password must contain one upper case letter, one lower case letter, a
                  number and a special character (e.g. ^ $ * . ! @ # % &amp;) and also must be at least 8 characters in
                  length.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <strong>I want to hear about everything BRFC has to offer</strong>
                <v-radio-group v-model="clubOptIn" :rules="toggleRules" row>
                  <v-radio label="Yes" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
                <p>Selecting this option will automatically apply all of the marketing preferences listed below.</p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-flex xs12 sm3>
                  <v-btn dark @click="showClubPrefs = !showClubPrefs">Manage</v-btn>
                </v-flex>
              </v-flex>
            </v-layout>

            <div v-if="showClubPrefs === true" class="club-prefs" required>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <strong>Club News & Updates</strong>
                  <v-radio-group v-model="clubPrefNews" row>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                  <p>General club communications including signings, fixture news, content.</p>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 pb-0>
                  <strong>Ticketing & Matchday Information</strong>
                  <v-radio-group v-model="clubPrefTickets" row>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                  <p>Ticket sales, match pushes, hospitality information and matchday updates.</p>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 pb-0>
                  <strong>Retail & Merchandise Offers </strong>
                  <v-radio-group v-model="clubPrefRetail" row>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                  <p>Product launches, offers and retail campaigns.</p>
                </v-flex>
              </v-layout>
            </div>

            <v-layout row>
              <v-flex xs12 pb-0>
                <strong>Official Partners & Sponsors (Third Party) </strong>
                <v-radio-group v-model="partnerOptIn" row :rules="toggleRules" required>
                  <v-radio label="Yes" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
                <p>Partner news, offers and competitions, EFL contractual sends.</p>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12 pb-0>
                <strong>Channels </strong>
                <p>Please select how you would like to hear from us.</p>
                <v-switch :label="`Email`" v-model="emailOptIn"></v-switch>
                <v-switch :label="`Direct Mail`" v-model="directmailOptIn"></v-switch>
                <v-switch :label="`SMS`" v-model="smsOptIn"></v-switch>

              </v-flex>
            </v-layout>

            <v-layout row v-if="configValues.communitySchemeMarketingEnabled === true">
              <v-flex xs12 pb-0>
                <strong>{{ configValues.communityScheme.name }} {{ communicationString }}:</strong>
                <v-switch
                  :label="`I want to receive ` + communicationStringLong + ` from ` + configValues.communityScheme.name + `.`"
                  v-model="foundationOptIn"></v-switch>
              </v-flex>
            </v-layout>



            <v-layout row>
              <v-flex xs12>
                <p>By making your selections above and clicking Continue, you confirm your marketing preferences. If you
                  choose to opt in, Blackburn Rovers Football Club and/or our official Partners & Sponsors may contact
                  you about your chosen marketing preferences using the methods you have selected.</p>
                <p>You can update your preferences or unsubscribe at any time via our Preference Centre. Your personal
                  data will be processed in line with our <a class="privacy-policy text-button"
                    :href="configStrings.clubPrivacyPolicyLink" target="_blank">Privacy Policy</a>, which explains how
                  we use your information and
                  your rights. By registering, you confirm that you have read and accept Blackburn Rovers Football &
                  Athletics’ Terms and Conditions and acknowledge that you have read the Club Privacy Policy.</p>
              </v-flex>
            </v-layout>

            <v-layout row align-center mx-1 py-0>
              <router-link to="/" class="text-button">Already registered?</router-link>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid">Register</button>
            </v-layout>

          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Registration',
  data() {

    return {
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      addressRules: [
        v => !!v || "You must fill in this address field",
      ],
      phoneNumberRules: [
        v => !!v || "Phone number is required.",
        v => /(\+?)([0-9]{7,15})/.test(v) || "Please provide a valid phone number",
        v => (v && v.length > 0 && v.length < 15) || "Please provide a valid phone number",
        v => /^\+/.test(v) || "Phone number must start with +"
      ],
      countryRules: [
        v => !!v || 'Country is required'
      ],
      dobRules: [
        v => !!v || 'Date of birth is required',
        v => (this.dobYear + '-' + ("0" + this.dobMonth).slice(-2) + '-' + ("0" + this.dobYear).slice(-2)).toString() < new Date().toISOString().split('T')[0] || "Date can't be in the future"
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)',
        v => (this.passConfirm.length >= 8 && v == this.passConfirm) || 'Password confirmation must match password'
      ],
      passConfirmRules: [
        v => (v == this.pass) || 'Password confirmation must match password'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      termsAgreeRules: [
        v => !!v || 'You must agree to continue'
      ],
      toggleRules: [
        v => (v === true || v === false) || 'You must select an option to continue'
      ],
      firstName: '',
      ssoid: '',
      lastName: '',
      username: '',
      pass: '',
      gender: "",
      address1: "",
      address2: "",
      address3: "",
      locality: "",
      region: "",
      postal_code: "",
      phone_number: "",
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      country: '',
      clubOptIn: null,
      clubAnyPrefsOptIn: null,
      showClubPrefs: false,
      clubPrefTickets: null,
      clubPrefNews: null,
      clubPrefRetail: null,
      foundationOptIn: false,
      partnerOptIn: null,
      emailOptIn: false,
      directmailOptIn: false,
      smsOptIn: false,
      termsAgree: true, // updated to true in Dec 2025 update as requested by Rovers
      passConfirm: '',
      error: null,
      loading: false,
      communicationString: 'Email',
      communicationStringLong: 'emails',
      countries: [],
      genderOptions: ['', 'Female', 'Male', 'Prefer not to say', 'Other'],
      days: [],
      months: [],
      years: []
    }
  },
  created() {

    if (this.configValues.accountRegistrationPreferencesAreEmailOnly === false) {
      this.communicationString = 'Communication'
      this.communicationStringLong = 'communications (via email, sms, phone or mail)'
    }

    this.populateDates()
    fetch("/countries.json")
      .then(r => r.json())
      .then(
        json => {
          this.countries = json.countries;
        },
        response => {
          console.log("Error loading json:", response);
        }
      );
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate()
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate()
    },
    dobDay: function (val, oldVal) {
      this.$refs.form.validate()
    },
    dobMonth: function (val, oldVal) {
      this.$refs.form.validate()
    },
    dobYear: function (val, oldVal) {
      this.$refs.form.validate()
    },
    clubOptIn: function (val, oldVal) {
      console.log("clubOptIn: " + val)
      console.log(typeof val)
      if (val === true) {
        this.clubPrefNews = true
        this.clubPrefTickets = true
        this.clubPrefRetail = true
        this.emailOptIn = true
        this.directmailOptIn = true
        this.smsOptIn = true
      } else {
        this.clubPrefNews = false
        this.clubPrefTickets = false
        this.clubPrefRetail = false
        // Only turn off channels if partner opt in is also associated as false/null
        if (this.partnerOptIn !== true) {
          this.emailOptIn = false
          this.directmailOptIn = false
          this.smsOptIn = false
        }
      }
    },
    clubPrefNews: function (val) {
      if (val === true) {
        this.enableChannels()
      } else {
        // If all granular prefs are false/null, turn off the main club opt-in
        if (this.clubPrefTickets !== true && this.clubPrefRetail !== true) {
          this.clubOptIn = false
        }
      }
    },
    clubPrefTickets: function (val) {
      if (val === true) {
        this.enableChannels()
      } else {
        if (this.clubPrefNews !== true && this.clubPrefRetail !== true) {
          this.clubOptIn = false
        }
      }
    },
    clubPrefRetail: function (val) {
      if (val === true) {
        this.enableChannels()
      } else {
        if (this.clubPrefNews !== true && this.clubPrefTickets !== true) {
          this.clubOptIn = false
        }
      }
    },
    partnerOptIn: function (val) {
      if (val === true) {
        this.enableChannels()
      } else {
        // Only turn off channels if club opt in is also associated as false/null
        if (this.clubOptIn !== true) {
          this.emailOptIn = false
          this.directmailOptIn = false
          this.smsOptIn = false
        }
      }
    }
  },
  methods: {
    enableChannels() {
      this.emailOptIn = true
      this.directmailOptIn = true
      this.smsOptIn = true
    },
    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    populateDates() {
      console.log('ADDING DATES')
      for (var d = 1; d < 32; d++) {
        this.days.push(d)
      }
      for (var m = 1; m < 13; m++) {
        this.months.push(m)
      }
      var thisYear = new Date().getFullYear()
      for (var y = thisYear + 1; y > 1900; y--) {
        this.years.push(y)
      }
    },
    crmXCMPush(username) {
      var crmXCMPushURL = process.env.VUE_APP_XCM_CRM_API + '/user/push/' + username
      console.log('XCM push url', crmXCMPushURL)
      return axios({
        method: 'get',
        url: crmXCMPushURL
      })
    },
    complete(username) {
      console.log('completing')
      var vm = this
      this.dataPush(username)
        .then(function (results) {
          console.log('redirecting after data push')
          vm.$router.push("/confirm");
        });
    },
    signUp(e) {
      e.preventDefault()
      this.loading = true
      var email = this.username.toLowerCase()
      var password = this.pass
      var firstName = this.firstName
      var lastName = this.lastName
      var termsAgree = this.termsAgree.toString()
      var gender = this.gender
      var phoneNumber = this.phone_number

      var attributesList = {
        "given_name": firstName,
        "family_name": lastName,
        "gender": gender,
        "custom:privacy_accepted": termsAgree,
        "phone_number": phoneNumber
      }

      var street_address =
        this.address1 + "\n" + this.address2 + "\n" + this.address3

      var address = {
        street_address: street_address,
        locality: this.locality,
        region: this.region,
        postal_code: this.postal_code,
        country: this.country
      };

      attributesList["address"] = JSON.stringify(address);

      if (this.clubPrefTickets.toString() === 'true' || this.clubPrefNews.toString() === 'true' || this.clubPrefRetail.toString() === 'true') {
        this.clubAnyPrefsOptIn = true
      } else {
        this.clubAnyPrefsOptIn = false
      }


      // regardless of if they select the main club opt-in, we need to push the granular prefs
      attributesList['custom:club_email'] = (this.clubAnyPrefsOptIn && this.emailOptIn).toString()
      attributesList['custom:club_sms'] = (this.clubAnyPrefsOptIn && this.smsOptIn).toString()
      attributesList['custom:club_direct'] = (this.clubAnyPrefsOptIn && this.directmailOptIn).toString()


      if (this.partnerOptIn.toString() === 'true') {
        attributesList['custom:partner_email'] = this.emailOptIn.toString()
        attributesList['custom:partner_sms'] = this.smsOptIn.toString()
        attributesList['custom:partner_direct'] = this.directmailOptIn.toString()
      }

      if (this.clubPrefNews.toString() === 'true') {
        attributesList['custom:club_pref_news'] = 'true'
      } else {
        attributesList['custom:club_pref_news'] = 'false'
      }

      if (this.clubPrefTickets.toString() === 'true') {
        attributesList['custom:club_pref_tickets'] = 'true'
      } else {
        attributesList['custom:club_pref_tickets'] = 'false'
      }

      if (this.clubPrefRetail.toString() === 'true') {
        attributesList['custom:club_pref_retail'] = 'true'
      } else {
        attributesList['custom:club_pref_retail'] = 'false'
      }

      if (this.configValues.communitySchemeMarketingEnabled === true) {
        if (this.foundationOptIn.toString() === 'true') {
          attributesList['custom:foundation_email'] = 'true'
        } else {
          attributesList['custom:foundation_email'] = 'false'
        }
      }

      if (this.dobDay && this.dobMonth && this.dobYear) {
        attributesList['birthdate'] = this.dobYear + '-' + this.pad(this.dobMonth, 2) + '-' + this.pad(this.dobDay, 2)
      }
      var vm = this
      this.$signUp(email, password, attributesList).subscribe((data) => {
        console.log("sign up successful, data:", data.user)
        var username = data.user.username
        vm.complete(username)
      },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          console.log(err.message)
          if (err.message === 'An account with the given email already exists.') {
            err.message = 'This is an existing ' + this.configStrings.clubName + ' ' + this.configStrings.productName + ' account - <a href="/forgot-password" class="text-button--login-error">Please click here to reset your password</a>'
          }
          vm.error = err
        });

    }
  }
}
</script>

<style lang="scss" scoped>
.password-notice {
  margin: 0 0 20px;
  padding: 0 0 40px;
  color: $core-grey;
  font-size: 15px;
  line-height: 22px;
  border-bottom: 1px solid $core-light-grey;
}

.v-input--switch__track.theme--light.error--text {
  color: rgba(0, 0, 0, 0.38) !important;
}

.v-input--selection-controls__ripple.error--text {
  color: $core-white !important;
}

.v-input--switch__thumb.theme--light.error--text {
  color: $core-lightest-grey !important;
}

.error {
  display: block;
}

.club-prefs {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid $core-light-grey;
}
</style>
